import React from 'react';
import { NumberInput, TextInput } from 'ui-toolkit';
import generateLabelToPayeeText from '../utilities/generateLabelToPayeeText';
import { createOnChangeHandlerGenerator } from '../utilities/createOnChangeHandlerGenerator';
import { CdLabelCell } from '../CdLabelCell.styles';
import IHasItemDataProps from './IHasItemDataProps';
import IHasItemEventProps from './IHasItemEventProps';
import IHasMetaDataModalProps from './IHasMetaDataModalProps';
import IHasMetaDataModalState from './IHasMetaDataModalState';
import { IItemWithoutShowSellerProps } from './IItemProps';
import PurchaseItemMetaDataModal, { IPurchaseItemMetaDataModalRef } from './PurchaseItemMetaDataModal';
import SharedPurchaseItemCells from './SharedPurchaseItemCells';
import './_BuyerCredit.scss';
import './_ModalPurchasePresentationItem.scss';
import { IBuyerCreditFromThirdPartyViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';

export interface IBuyerCreditFromThirdPartyProps
  extends IItemWithoutShowSellerProps,
    IHasItemDataProps<IBuyerCreditFromThirdPartyViewItem>,
    IHasItemEventProps<IBuyerCreditFromThirdPartyViewItem>,
    IHasMetaDataModalProps {
  onFocus?: () => void;
  onBlur?: (event: React.FocusEvent) => void;
}

type IBuyerCreditFromThirdPartyState = IHasMetaDataModalState;

export default class BuyerCreditFromThirdParty extends React.Component<
  IBuyerCreditFromThirdPartyProps,
  IBuyerCreditFromThirdPartyState
> {
  public state = { expanded: !this.props.disableAutoExpand && this.props.data.new };
  private modal = React.createRef<IPurchaseItemMetaDataModalRef>();
  private firstInput: HTMLInputElement | null = null;

  public render() {
    const { data, onChange, hasEditPermissions } = this.props;
    const generateDefaultOnChangeHandler = createOnChangeHandlerGenerator(data, onChange);
    const onPaidByOthersChangeEvent = generateDefaultOnChangeHandler('paid_by_others');
    const labelOnChangeEvent = generateDefaultOnChangeHandler('label');
    const payeeOnChangeEvent = generateDefaultOnChangeHandler('payee');
    return (
      <SharedPurchaseItemCells
        {...this.props}
        paidByOthersDisplay="text"
        className="modal-purchase-presentation-item buyer-credit"
        onBlur={this.onBlur}
        onFocus={this.onFocus}
        hasEditPermissions={hasEditPermissions}
      >
        <PurchaseItemMetaDataModal
          expanded={this.state.expanded}
          expandedLabel={
            <CdLabelCell gridTemplateColumns={'1fr min-content 1fr'}>
              <TextInput
                label={'Name'}
                onChange={labelOnChangeEvent}
                placeholder="Name"
                getInputRef={this.setFirstInput}
                value={data.label}
                readOnly={!hasEditPermissions}
                debounceOnValueChange
              />
              <span>to</span>
              <TextInput
                label={'Payee'}
                onChange={payeeOnChangeEvent}
                placeholder="Payee"
                getInputRef={this.setFirstInput}
                value={data.payee}
                readOnly={!hasEditPermissions}
                debounceOnValueChange
              />
            </CdLabelCell>
          }
          hideBorder={true}
          label={generateLabelToPayeeText(data.label, data.payee)}
          onToggle={this.onModalToggleEvent}
          ref={this.modal}
        >
          <div className="buyer-credit__fields">
            <NumberInput
              mode="currency"
              label="Amount"
              className="buyer-credit__amount"
              onBlur={this.onBlur}
              onFocus={this.onFocus}
              onChange={onPaidByOthersChangeEvent}
              value={data.paid_by_others}
              readOnly={!hasEditPermissions}
              debounceOnValueChange
            />
          </div>
        </PurchaseItemMetaDataModal>
      </SharedPurchaseItemCells>
    );
  }

  private setFirstInput = (element: HTMLInputElement) => {
    this.firstInput = element;
  };

  private onBlur = (event: React.FocusEvent) => {
    const { onBlur } = this.props;
    const node = this.modal.current;
    if (node && event.relatedTarget && !node.modalContains(event.relatedTarget as HTMLElement)) {
      this.setState({
        expanded: false,
      });
    }
    if (onBlur) {
      onBlur(event);
    }
  };

  private onFocus = () => {
    const { onFocus } = this.props;
    if (onFocus) {
      onFocus();
    }
  };

  private onModalToggleEvent = (expanded: boolean) => {
    this.setState({ expanded });
    if (this.firstInput) {
      this.firstInput.focus();
    }
  };
}
